import {retrieve, remove} from './StyleStorage';
import {Segment} from '@lookiero/quiz';

const QUIZ_ID = 'quizId';
const QUIZ_SEGMENT = 'quizSegment';
const CUSTOMER_ID = 'customerId';

const getQuizId = async (): Promise<string> => (await retrieve(QUIZ_ID)).quizId;
const deleteQuizId = async (): Promise<void> => await remove(QUIZ_ID);

const getQuizSegment = async (): Promise<Segment> => (await retrieve(QUIZ_SEGMENT)).segment;
const deleteQuizSegment = async (): Promise<void> => await remove(QUIZ_SEGMENT);

const getCustomerId = async (): Promise<string | null> => (await retrieve(CUSTOMER_ID))?.customerId || null;
const deleteCustomerId = async (): Promise<void> => await remove(CUSTOMER_ID);

const apiStyle = {
  getQuizId,
  deleteQuizId,
  getQuizSegment,
  deleteQuizSegment,
  getCustomerId,
  deleteCustomerId,
};

export {apiStyle};
